/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EventTypeCountStats } from '../models/EventTypeCountStats';
import type { HourlyStats } from '../models/HourlyStats';
import type { WidgetAnalyticEventRequest } from '../models/WidgetAnalyticEventRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AnalyticsControllerService {
    /**
     * @param requestBody
     * @returns any No content
     * @throws ApiError
     */
    public static putMessage(
        requestBody: WidgetAnalyticEventRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/analytics',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param agentId
     * @param start
     * @param end
     * @param distinct
     * @param mode
     * @param countries
     * @returns EventTypeCountStats Successful response
     * @throws ApiError
     */
    public static getEventTypeStats(
        agentId: string,
        start: string,
        end: string,
        distinct?: boolean,
        mode?: 'INCLUDE' | 'EXCLUDE',
        countries?: Array<string>,
    ): CancelablePromise<Array<EventTypeCountStats>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/stats/types',
            query: {
                'agentId': agentId,
                'distinct': distinct,
                'start': start,
                'end': end,
                'mode': mode,
                'countries': countries,
            },
        });
    }
    /**
     * @param start
     * @param end
     * @param agentId
     * @returns HourlyStats Successful response
     * @throws ApiError
     */
    public static getHourlyStats(
        start: string,
        end: string,
        agentId?: string,
    ): CancelablePromise<HourlyStats> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/stats/hourly',
            query: {
                'agentId': agentId,
                'start': start,
                'end': end,
            },
        });
    }
    /**
     * @param agentId
     * @param start
     * @param end
     * @returns string Successful response
     * @throws ApiError
     */
    public static getCountries(
        agentId?: string,
        start?: string,
        end?: string,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/stats/countries',
            query: {
                'agentId': agentId,
                'start': start,
                'end': end,
            },
        });
    }
}
